import { statusDisplayNameForTrackings } from '@rsos/constants/alertStatuses';
import { gspx } from '@rsos/gainsight';

export const trackClickAlert = (
  alertStatus,
  appName,
  isSupplementalAlert = false,
  isUnread = false,
  selectedAlertID,
  irpVersion,
) => {
  let displayAppName = 'RSP';
  if (appName === 'central_station') {
    displayAppName = 'CSP';
  }
  let displayStatus = statusDisplayNameForTrackings[alertStatus];

  if (isSupplementalAlert) {
    gspx.trackCustomEvent('Alert', {
      irpVersion,
      name: `Click supplemental Alert in ${displayAppName}`,
      Category: 'Alert',
      'Launched date': new Date(),
      AlertID: selectedAlertID,
    });
    if (alertStatus === 'CANCELED') {
      gspx.trackCustomEvent('Alert', {
        irpVersion,
        name: `Click Canceled Alert (supplemental) in  ${displayAppName}`,
        Category: 'Alert',
        'Launched date': new Date(),
        AlertID: selectedAlertID,
      });
    }
  } else {
    if (displayAppName === 'RSP' && alertStatus === 'DISPATCH_REQUESTED') {
      displayStatus = 'New';
    }

    gspx.trackCustomEvent('Alert', {
      irpVersion,
      name: `Click ${displayStatus} Alert in ${displayAppName}`,
      Category: 'Alert',
      'Launched date': new Date(),
      AlertID: selectedAlertID,
    });
  }
  if (isUnread) {
    gspx.trackCustomEvent('Alert', {
      irpVersion,
      name: `Click ${displayStatus} Alert with unread indicator in ${displayAppName}`,
      Category: 'Alert',
      'Launched date': new Date(),
      AlertID: selectedAlertID,
    });
  }
};
